<template>
  <div class="components-page__nodeWrapper">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'nodeWrapper',
  props: {
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
.components-page__nodeWrapper {
  display: inline-flex;
  width: 100%;
  flex-direction: column;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  padding: 0 50px;
  position: relative;
}
</style>
